<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <div class="d-flex align-items-center">
                                <div class="edit">
                                    <button title="back page" (click)="backToAttendancePage()">
                                        <span><i class="ri-arrow-left-line"></i></span>
                                    </button>
                                </div>
                                <h3 class="px-3">Short Leave</h3>
                            </div>
                        </div>
                        <div class="col-sm-6" style="display: flex; justify-content: flex-end; align-items: center;">
                            <div>
                                <button type="button" title="Create" (click)="createOpenModal()" data-bs-toggle="modal"
                                    data-bs-target="#shortLeave" class="btn btn-icon">
                                    <i class="ri-add-line"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="canvas-header row justify-content-between align-items-center" *ngIf="this.isAdmin || this.isSupervisor">
                        <div class="row p-0">
                            <div class="col-sm-12 p-0">
                                <form [formGroup]="employeeForm">
                                    <div class="canvas-data px-0">
                                        <div class="row m-0">
                                            <div class="col-sm-3 col-md-6 col-lg-3 col-xl-3 mb-2">
                                                <div class="input">
                                                    <div class="input-item">
                                                        <input list="userDropdownList" formControlName="userId"
                                                            placeholder="Select Employee Name" value=""
                                                            onfocus="this.value=''" onchange="this.blur();" />
                                                        <datalist id="userDropdownList">
                                                            <option [value]="item" *ngFor="let item of userDropdownList">
                                                            </option>
                                                        </datalist>
                                                        <label class="floating-label">Employee Name</label>
                                                        <i class="ri-user-line"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3 col-md-6 col-lg-3 col-xl-3 text-end text-right">
                                                <div class="row justify-content-center">
                                                    <div class="col-sm-6">
                                                        <button type="button" class="btn" (click)=getShortLeave()>
                                                            <div>Submit</div>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <ag-grid-angular style="height: 620px;" class="ag-theme-material" (gridReady)="onGridReady($event)"
                        [rowData]="rowData" [columnDefs]="columnDefs" pagination="true" [defaultColDef]="defaultColDef"
                        [suppressRowClickSelection]="true" [rowSelection]="rowSelection"
                        (selectionChanged)="onSelectionChanged($event)" paginationPageSize=10>
                    </ag-grid-angular>
                </div>
            </section>
        </section>
    </article>
</main>

<!-- Create Short Leave -->
<div class="modal fade" id="shortLeave" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="shortLeaveForm">
                <div class="modal-header">
                    <h5 class="modal-title">Short Leave</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="input" *ngIf="!isAdmin">
                        <div class="input-item">
                            <input formControlName="userId" type="text" disabled>
                            <label for="userId" class="floating-label-special">Employee</label>
                            <i class="ri-user-line"></i>
                        </div>
                    </div>
                    <div class="input" *ngIf="isAdmin">
                        <div class="input-item">
                            <input list="userDropdownList" formControlName="userId" placeholder="Select Employee Name" value="" onfocus="this.value=''" onchange="this.blur();" />
                                <datalist id="userDropdownList">
                                    <option [value]="item" *ngFor="let item of userDropdownList"></option>
                                </datalist>
                            <label for="userId" class="floating-label-special">Employee</label>
                            <i class="ri-user-line"></i>
                        </div>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="leaveDate" type="date" min="{{this.minDate}}">
                            <label for="leaveDate" class="floating-label-special">Date</label>
                            <i class="ri-calendar-line"></i>
                        </div>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <select formControlName="firstHalf">
                                <option value="" disabled selected>Select</option>
                                <option [ngValue]="true">First Half</option>
                                <option [ngValue]="false">Second Half</option>
                            </select>
                            <label for="firstHalf" class="floating-label-special">Short Leave For</label>
                            <i class="ri-logout-box-r-line"></i>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" id="closeCreateModal" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" (click)="createShortLeave()">Create</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal fade" id="deleteShift" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form action="">
                <div class="modal-header">
                    <h5 class="modal-title">Are you sure want to delete?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="text-center">
                        <p>{{deleteConfirmationMsg}}?</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="closeModalDeleteShift" type="button" class="btn btn-secondary"
                        data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="selectedCheckboxData.length > 0"
                        (click)="deleteShift()">Yes Delete</button>
                </div>
            </form>
        </div>
    </div>
</div>